const Products = () => {
    return (
        <div className="text-center p-6">
            <h1 className="text-3xl font-bold text-green-600">📦 产品展示</h1>
            <p className="text-gray-700 mt-2">看看我们的煎饼果子有哪些口味吧！</p>
        </div>
    );
};

export default Products;